module.exports = {"230184100":"五常镇","230184101":"拉林满族镇","230184102":"山河镇","230184103":"小山子镇","230184104":"安家镇","230184105":"牛家满族镇","230184106":"杜家镇","230184107":"背荫河镇","230184108":"冲河镇","230184109":"沙河子镇","230184110":"向阳镇","230184111":"龙凤山镇","230184200":"兴盛乡","230184201":"志广乡","230184202":"卫国乡","230184203":"常堡乡","230184206":"民意乡","230184209":"红旗满族乡","230184210":"八家子乡","230184211":"民乐朝鲜族乡","230184212":"营城子满族乡","230184214":"长山乡","230184215":"兴隆乡","230184216":"二河乡","230184400":"山河屯林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230184.json
// module id = 632
// module chunks = 0